"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _index2 = require("../ButtonTertiary/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var CloseButton = exports.CloseButton = (0, _styledComponents["default"])(_index2.ButtonTertiary).withConfig({
  displayName: "CloseButton",
  componentId: "sc-abn00m-0"
})(["position:absolute;right:4px;top:50%;transform:translate(0,-50%);[dir='rtl'] &{right:unset;left:4px;}@media (min-width:", "){right:12px;[dir='rtl'] &{left:12px;}}&:active{transform:translate(0,-50%) scale(1);}&:hover{transform:translate(0,-50%) scale(", ");}"], _encoreFoundation.screenSmMin, _index.buttonHoverScale);